module.exports = __webpack_public_path__ + "static/media/eliminar.a8ff9d72.png";